import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth, homeForRole } from './AuthContext';
import './Portal.css';

export default function PortalLogin() {
  const { user, loading, installed, unreachable, signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (loading) {
    return (
      <div className="pt-app">
        <div className="pt-loading">Checking your session…</div>
      </div>
    );
  }

  if (user) {
    return <Redirect to={homeForRole(user.role)} />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
      // The redirect above fires once `user` lands in context.
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="pt-app pt-auth">
      <div className="pt-auth-card">
        <p className="pt-auth-eyebrow">Northwoods Handy</p>
        <h1 className="pt-auth-title">Portal sign in</h1>
        <p className="pt-auth-sub">
          For the business owner and the webmaster. Customers do not need an account — this is not the
          contact form.
        </p>

        {unreachable && (
          <div className="pt-notice pt-notice-error" style={{ marginBottom: 18 }}>
            The portal backend is not responding. Confirm the <code>/api</code> folder was uploaded to the
            server and that PHP is enabled.
          </div>
        )}

        {!unreachable && !installed && (
          <div className="pt-notice pt-notice-warn" style={{ marginBottom: 18 }}>
            No accounts exist yet. Open <code>/api/setup.php?key=YOUR_SETUP_KEY</code> to create the
            webmaster account, then come back here.
          </div>
        )}

        <form className="pt-form" onSubmit={handleSubmit}>
          <div className="pt-field">
            <label className="pt-label" htmlFor="pt-email">
              Email
            </label>
            <input
              id="pt-email"
              className="pt-input"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="pt-field">
            <label className="pt-label" htmlFor="pt-password">
              Password
            </label>
            <input
              id="pt-password"
              className="pt-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="pt-notice pt-notice-error">{error}</div>}

          <button className="pt-btn pt-btn-primary pt-btn-block" type="submit" disabled={busy}>
            {busy && <span className="pt-spinner" />}
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="pt-auth-foot">
          <a href="/">← Back to the website</a>
        </div>
      </div>
    </div>
  );
}
